import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import About from "./components/about";
import { Process } from "./components/process";
import ProjectsCarousel from "./components/ProjectsCarousel";
import CTA from "./components/CTA";
import Vision from "./components/Vision";
import FAQ from "./components/FAQ";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton"; // <-- NEW IMPORT
import { Footer } from "./components/footer";
import WhyChooseUs from "./components/WhyChooseUs";
import StepOneForm from "./components/StepOneForm";
import StepTwoForm from "./components/StepTwoForm";
import StepThreeForm from "./components/StepThreeForm";
import StepFourForm from "./components/StepFourForm";

import JsonData from "./data/data.json";
import "./App.css";

function MultiStepFlow() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const handleNext = (newData) => {
    const updatedData = { ...formData, ...newData };
    setFormData(updatedData);

    if (step === 1) navigate("/next-step");
    else if (step === 2) navigate("/third-step");
    else if (step === 3) navigate("/final-step");

    setStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (step === 2) navigate("/get-started");
    else if (step === 3) navigate("/next-step");
    else if (step === 4) navigate("/third-step");

    setStep((prev) => prev - 1);
  };

  return (
    <Routes>
      <Route
        path="/get-started"
        element={<StepOneForm onNext={handleNext} initialData={formData} />}
      />
      <Route
        path="/next-step"
        element={
          <StepTwoForm
            onNext={handleNext}
            onBack={handleBack}
            initialData={formData}
          />
        }
      />
      <Route
        path="/third-step"
        element={
          <StepThreeForm
            onNext={handleNext}
            onBack={handleBack}
            allData={formData}
          />
        }
      />
      <Route
        path="/final-step"
        element={<StepFourForm formData={formData} onBack={handleBack} />}
      />
    </Routes>
  );
}

export default function App() {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navigation />
      <Routes>
        {/* Landing page */}
        <Route
          path="/"
          element={
            <>
              <Header data={landingPageData.Header} />
              <Process />
              <CTA />
              <FAQ />
            </>
          }
        />
        {/* NEW ROUTE: Projects page */}
        <Route
          path="/projects"
          element={
            <div style={{ paddingTop: '90px' }}>
              <ProjectsCarousel projects={JsonData.Projects || []} />
            </div>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <About data={landingPageData.About} />
              <Vision data={landingPageData.Vision} />
              <WhyChooseUs data={landingPageData.WhyChooseUs} />

            </>
          }
        />

        {/* Multi-step form flow */}
        <Route path="/*" element={<MultiStepFlow />} />
      </Routes>
      <Footer />
      {/* Scroll to Top Button (appears when scrolling down) */}
      <ScrollToTopButton /> {/* <-- NEW COMPONENT ADDED HERE */}

      {/* Ensure Bootstrap Icons CSS is available for the button icon */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />
    </Router>
  );
}